import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureGtagStub, GA_MEASUREMENT_ID, loadGtagScript } from './gtag';

/**
 * Google Analytics 4 (gtag). Set `VITE_GA_MEASUREMENT_ID` (e.g. G-XXXXXXXXXX).
 * Sends a page_view on each SPA navigation via `gtag('config', …, { page_path })`.
 */
export function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    loadGtagScript(GA_MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    ensureGtagStub();
    window.gtag!('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);

  return null;
}
